// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import ConstantCurve from '../../../addons/particlepack/curves/ConstantCurve';
import Curve from '../../../addons/particlepack/curves/Curve';
import ObjectUtils from '../../../util/ObjectUtils';

/**
 * Three scalar curves. Can be converted to a vec4-valued expression in GLSL code.
 */
class Vector4Curve extends Curve {
  /**
   * @param {object} [options]
   * @param {Curve} [options.x]
   * @param {Curve} [options.y]
   * @param {Curve} [options.z]
   * @param {Curve} [options.w]
   */
  constructor(options) {
    options = options || {};

    options = ObjectUtils.clone(options);
    options.type = 'vec4';
    super(options);

    this.x = options.x ? options.x.clone() : new ConstantCurve();
    this.y = options.y ? options.y.clone() : new ConstantCurve();
    this.z = options.z ? options.z.clone() : new ConstantCurve();
    this.w = options.w ? options.w.clone() : new ConstantCurve({ value: 1 });

    if (this.x.type !== 'float' || this.y.type !== 'float' || this.z.type !== 'float' || this.w.type !== 'float') {
      throw new Error('Vector4Curve must have scalar components.');
    }
  }

  toGLSL(timeVariableName, lerpValueVariableName) {
    return `vec4(${[this.x, this.y, this.z, this.w].map(c => c.toGLSL(timeVariableName, lerpValueVariableName)).join(',')})`;
  }

  integralToGLSL(timeVariableName, lerpValueVariableName) {
    return `vec4(${[this.x, this.y, this.z, this.w].map(c => c.integralToGLSL(timeVariableName, lerpValueVariableName)).join(',')})`;
  }

  getVec4ValueAt(t, lerpValue, store) {
    store.setDirect(
      this.x.getValueAt(t, lerpValue),
      this.y.getValueAt(t, lerpValue),
      this.z.getValueAt(t, lerpValue),
      this.w.getValueAt(t, lerpValue),
    );
  }

  getVec4IntegralValueAt(t, lerpValue, store) {
    store.setDirect(
      this.x.getIntegralValueAt(t, lerpValue),
      this.y.getIntegralValueAt(t, lerpValue),
      this.z.getIntegralValueAt(t, lerpValue),
      this.w.getIntegralValueAt(t, lerpValue),
    );
  }
}

export default Vector4Curve;
